import { useState } from 'react'
import { TypographyV2 } from '@which/seatbelt'

import { QuestionOption } from './QuestionOption'
import styles from './QuestionScreen.module.scss'

export type Option = {
  label: string
  tooltip?: string
}

export type QuestionScreenProps = {
  question: string
  options: Option[]
  screenName: string // used for analytics
  selectedIndex?: number
  callback: (optionIndex: number) => void
  category: string
  onSkip?: () => void
}

export const QuestionScreen = ({
  question,
  options,
  screenName,
  selectedIndex,
  category,
  callback,
  onSkip,
}: QuestionScreenProps) => {
  const [openTooltipIndex, setOpenTooltipIndex] = useState<number | null>(null)

  if (selectedIndex !== undefined && (selectedIndex < 0 || selectedIndex >= options.length)) {
    console.warn(`Selected index ${selectedIndex} is out of bounds for options array.`)
  }

  return (
    <div className={styles.questionScreen}>
      <div>
        <TypographyV2 tag="p" textStyle="sb-text-interface-body-default-regular">
          {question}
        </TypographyV2>
        {onSkip && (
          <button type="button" onClick={onSkip} className={styles.skipLink}>
            Skip question
          </button>
        )}
      </div>
      <div className={styles.optionsContainer}>
        {options.map((option, optionIndex) => (
          <QuestionOption
            key={`${option.label}-${optionIndex}`}
            option={option}
            category={category}
            optionIndex={optionIndex}
            screenName={screenName}
            isSelected={optionIndex === selectedIndex}
            isTooltipOpen={openTooltipIndex === optionIndex}
            onSelect={callback}
            onTooltipOpen={setOpenTooltipIndex}
            onTooltipClose={() => setOpenTooltipIndex(null)}
          />
        ))}
      </div>
    </div>
  )
}
